var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeOrbitingAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0187 16.2395C13.9123 16.2395 16.258 13.8937 16.258 11.0001C16.258 8.10648 13.9123 5.76074 11.0187 5.76074C8.12504 5.76074 5.7793 8.10648 5.7793 11.0001C5.7793 13.8937 8.12504 16.2395 11.0187 16.2395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1651_9667",
    maskUnits: "userSpaceOnUse",
    x: -0.257812,
    y: -0.25,
    width: 16,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.257812,
    y: -0.25,
    width: 16,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.742188 11C0.742188 5.32915 5.34966 0.75 11.0188 0.75C15.6256 0.75 16.3332 5.31868 12.9779 8.51064C16.0263 5.15311 15.2946 1.46277 11.0188 1.46277C5.75792 1.46277 1.48155 5.73913 1.48155 11C1.48155 16.2609 5.75792 20.5372 11.0188 20.5372V21.0372L10.9922 21.0372V21.25C5.34923 21.25 0.742188 16.6704 0.742188 11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.742188 11C0.742188 5.32915 5.34966 0.75 11.0188 0.75C15.6256 0.75 16.3332 5.31868 12.9779 8.51064C16.0263 5.15311 15.2946 1.46277 11.0188 1.46277C5.75792 1.46277 1.48155 5.73913 1.48155 11C1.48155 16.2609 5.75792 20.5372 11.0188 20.5372V21.0372L10.9922 21.0372V21.25C5.34923 21.25 0.742188 16.6704 0.742188 11Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9779 8.51064L12.7928 8.34259C12.7024 8.44218 12.707 8.59546 12.8032 8.68946C12.8994 8.78346 13.0527 8.78448 13.1502 8.69177L12.9779 8.51064ZM11.0188 20.5372H11.2688V20.2872H11.0188V20.5372ZM11.0188 21.0372L11.0185 21.2872L11.2688 21.2876V21.0372H11.0188ZM10.9922 21.0372L10.9925 20.7872L10.7422 20.7869V21.0372H10.9922ZM10.9922 21.25V21.5H11.2422V21.25H10.9922ZM11.0188 0.5C5.21246 0.5 0.492188 5.19021 0.492188 11H0.992188C0.992188 5.46809 5.48686 1 11.0188 1V0.5ZM13.1502 8.69177C14.8721 7.05371 15.5852 5.02963 15.2285 3.38048C15.0495 2.55289 14.6011 1.82734 13.8867 1.3111C13.1738 0.795979 12.2115 0.5 11.0188 0.5V1C12.1295 1 12.9832 1.27511 13.5938 1.71636C14.2029 2.1565 14.5855 2.77262 14.7398 3.48619C15.0498 4.91937 14.439 6.77561 12.8056 8.32951L13.1502 8.69177ZM11.0188 1.71277C13.0837 1.71277 14.2029 2.5932 14.5024 3.7884C14.8103 5.01689 14.2881 6.69568 12.7928 8.34259L13.163 8.67869C14.7161 6.96807 15.3523 5.12292 14.9874 3.66686C14.6142 2.1775 13.2297 1.21277 11.0188 1.21277V1.71277ZM1.73155 11C1.73155 5.87721 5.89599 1.71277 11.0188 1.71277V1.21277C5.61985 1.21277 1.23155 5.60106 1.23155 11H1.73155ZM11.0188 20.2872C5.89599 20.2872 1.73155 16.1228 1.73155 11H1.23155C1.23155 16.3989 5.61985 20.7872 11.0188 20.7872V20.2872ZM11.2688 21.0372V20.5372H10.7688V21.0372H11.2688ZM10.9919 21.2872L11.0185 21.2872L11.0191 20.7872L10.9925 20.7872L10.9919 21.2872ZM11.2422 21.25V21.0372H10.7422V21.25H11.2422ZM0.492188 11C0.492188 16.8089 5.2116 21.5 10.9922 21.5V21C5.48686 21 0.992188 16.5319 0.992188 11H0.492188Z",
    fill: "black",
    mask: "url(#path-2-outside-1_1651_9667)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 91",
    cx: 11.7422,
    cy: 10,
    r: 1,
    fill: "#08080A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeOrbitingAnalysis);
export default __webpack_public_path__ + "static/media/DeOrbitingAnalysis.2599a34369d3711393607120f40a281f.svg";
export { ForwardRef as ReactComponent };